import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import getLocale from '../../i18n/getLocale';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import AirportOperatorLocationsAdd from './Elements/AirportOperatorLocationsAdd'
import AirportOperatorTpoAdd from './Elements/AirportOperatorTpoAdd'
import AirportOperatorPpmAdd from './Elements/AirportOperatorPpmAdd'
import AirportOperatorPpeAdd from './Elements/AirportOperatorPpeAdd'

class AirportOperatorsEdit extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      id: null,
      name: null,
      email: null,
      airport_operator_locations: {},
      airport_operator_landing_fees: {},
      airport_operator_maneuvering_area_fees: {},
      airport_operator_aircraft_stand_fees: {},
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();
    this.loadData = this.loadData.bind(this);
    this.edit = this.edit.bind(this);
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }  
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/operador/'+self.props.match.params.id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url', '/operadores');
        if (responseJson.status === 'success') {
          self.setState({
            id: responseJson.data.main.id,
            name: responseJson.data.main.name,
            email: responseJson.data.main.email,
            airport_operator_locations: responseJson.data.airport_operator_locations,
            airport_operator_landing_fees: responseJson.data.airport_operator_landing_fees,
            airport_operator_maneuvering_area_fees: responseJson.data.airport_operator_maneuvering_area_fees,
            airport_operator_aircraft_stand_fees: responseJson.data.airport_operator_aircraft_stand_fees,
            locations_select: responseJson.data.locations_select,
            currencies_select: responseJson.data.currencies_select,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      });
    });
  }

  // Fetch salvando a edição
  edit(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      id: this.state.id,
      name: this.state.name,
      email: this.state.email,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/operador', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.handleAlert(responseJson.message, responseJson.status, 'open');
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  render() {
    var self = this;
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.titulo}</h3>
      <Link to="/operadores" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.edit}>
        <div className="row">
          <div className="col-md-6 form-group">
            <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.formulario.Nome}</label>
            <input type="text" className="form-control" name="name" value={this.state.name} onChange={this.handleChange.bind(this, 'name')} />
          </div>
          <div className="col-md-6 form-group">
            <label>{this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.formulario.Email}</label>
            <input type="text" className="form-control" name="email" value={this.state.email} onChange={this.handleChange.bind(this, 'email')} />
          </div>
        </div>
        <hr/>
        <button type={'submit'} className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> {this.locale.OperadoresAeroporto.EditarOperadoresAeroporto.formulario.botaoSalvarEdicao}</button>
      </form>
      <hr />
      <AirportOperatorLocationsAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} locations_select={this.state.locations_select} airport_operator_locations={this.state.airport_operator_locations}/>
      <hr />
      <AirportOperatorTpoAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airport_operator_landing_fees} currencies_select={this.state.currencies_select}/>
      <hr />
      <AirportOperatorPpmAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airport_operator_maneuvering_area_fees} currencies_select={this.state.currencies_select}/>
      <hr />
      <AirportOperatorPpeAdd RequestApi={self.refs.request_api} handleAlert={this.handleAlert} id={this.state.id} data={this.state.airport_operator_aircraft_stand_fees} currencies_select={this.state.currencies_select}/>
    </div>
  </div>
</div>
    );
  }
}

export default AirportOperatorsEdit;



// WEBPACK FOOTER //
// ./src/Components/AirportOperators/AirportOperatorsEdit.js